import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { McRAILoader } from './services/loader.service';
import { LoaderComponent } from './components/loader/loader.component';

export * from './services/loader.service'
export * from './services/loader2.service'

@NgModule({
  imports: [
    CommonModule,
    OverlayModule
  ],
  declarations: [
    LoaderComponent
  ],
  entryComponents: [
    LoaderComponent
  ],
  providers: [
    McRAILoader,
  ],
  exports: [
    LoaderComponent
  ]
})
export class McRAILoaderModule { }
